import { Box } from "@mui/material";
import { styled } from "styled-components";

export const ContentList = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 4px;
  height: calc(100vh - 335px);
`;

export const AccordionContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
